import { isYeetWorkerStalled } from "contracts/api/crawl/run-read.responses";
import type { PlaygroundRunOutputResponse } from "contracts/api/playground";
import { isActiveCrawlRunStatus } from "contracts/enums/core";
import { Show } from "solid-js";
import { RunFindings } from "./RunFindings";
import { RunScoreTables } from "./RunScoreTables";
import { RunTelemetry } from "./RunTelemetry";

/** The full result of one playground run, composed from the telemetry, score,
 * and findings sections. Shared by the run-detail route and each compare column
 * so the two never drift. */
export function RunOutputPanel(props: {
  data: PlaygroundRunOutputResponse;
  runId: string;
}) {
  const d = () => props.data;
  const isEmpty = () =>
    !d().attempt &&
    d().screenshots.length === 0 &&
    d().scores.length === 0 &&
    d().findings.length === 0 &&
    d().assessments.length === 0 &&
    d().judgments.length === 0;
  const emptyMessage = () => {
    if (!isActiveCrawlRunStatus(d().run.status))
      return "No results were recorded for this run.";
    const worker = d().yeetWorker;
    return isYeetWorkerStalled(worker)
      ? `No analysis worker is connected. ${worker.queued} page${worker.queued === 1 ? " is" : "s are"} queued.`
      : "The agent is still working — results will appear here.";
  };

  return (
    <>
      <Show when={isEmpty()}>
        <div class="compare-empty">{emptyMessage()}</div>
      </Show>
      <RunTelemetry
        attempt={d().attempt}
        screenshots={d().screenshots}
        runId={props.runId}
      />
      <RunScoreTables scores={d().scores} judgments={d().judgments} />
      <RunFindings findings={d().findings} assessments={d().assessments} />
    </>
  );
}
